import type { FunctionComponentWithRef } from "react";
import { graphql, useFragment } from "react-relay";

import { withHighlightedHeadline } from "scmp-app/components/content/content-item-render/highlight/hoc";
import { useContentItemProviders } from "scmp-app/components/content/content-item-render/hooks";
import type { ContentItemRenderVariantProps } from "scmp-app/components/content/content-item-render/types";
import type { homeLatestV2ContentItemContent$key } from "scmp-app/queries/__generated__/homeLatestV2ContentItemContent.graphql";

import {
  ActionBar,
  ActionBarContainer,
  Container,
  Headline,
  Section,
  StyledEntityLink,
} from "./styles";

export type Props = ContentItemRenderVariantProps & {
  reference: homeLatestV2ContentItemContent$key;
};

const Component: FunctionComponentWithRef<Props, HTMLDivElement> = ({
  className,
  onClick,
  ref,
  reference,
}) => {
  const content = useFragment(
    graphql`
      fragment homeLatestV2ContentItemContent on Content {
        entityId
        urlAlias
        ...entityLink
        ...hooksContentItemProvidersContent
          @arguments(
            withActionBar: true
            withSections: true
            withHeadline: true
            withPublishedDate: true
          )
      }
    `,
    reference,
  );
  const providers = useContentItemProviders(content);

  return (
    <Container className={className} ref={ref}>
      <ActionBarContainer>
        <ActionBar>
          {providers.actionBar({
            displayDateVariant: "publishedDate",
            isBookmarkVisible: false,
            isCommentsVisible: false,
            isIconVisible: false,
          })}
        </ActionBar>
        <Section>{providers.sections()}</Section>
      </ActionBarContainer>
      <StyledEntityLink
        onClick={() => onClick?.(content.entityId, content.urlAlias)}
        reference={content}
      >
        <Headline>
          {providers.headline({
            preferSocialHeadline: true,
          })}
        </Headline>
      </StyledEntityLink>
    </Container>
  );
};

Component.displayName = "ContentItemHomeLatestV2";

export const ContentItemHomeLatestV2 = withHighlightedHeadline(Component);
